import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Router, Route } from "react-router-dom";

import { getStore } from "./store/configureStore";
import { getHistory } from './util/configureHistory';

import * as settings from "./actions/settingActions";
import * as layout from "./actions/e-loketLayoutActions";

import * as reference from "./actions/referentieActions";

import "../css/site.css";
import "../node_modules/toastr/build/toastr.min.css";

import App from "../js/components/App";
import { authClientApplication } from "./authentication/authClientApplication";
import { MsalProvider } from "@azure/msal-react";

const store = getStore();
const history = getHistory();

store.dispatch(settings.loadSettings());
store.dispatch(layout.loadDefaultLayout());
store.dispatch(reference.loadReferences());

render(
	<Provider store={store}>
		<Router history={history}>
			<Route path={store.getState().settings.siteRoot} >
				{({ match, location }) => {
					return <MsalProvider instance={authClientApplication}>
						<App match={match} location={location}/>
					</MsalProvider>;
				}}
			</Route>
		</Router >
	</Provider>, document.getElementById('app')
);

//http://localhost:3004/veldtoertochten.portal/e-loket/4390c5b2-5e7a-e611-80d7-c4346baccc44/demo/234234
